import { h } from '@debbie/cortex/dist/index.js';
import { useProcedures } from '@debbie/cortex/dist/procedures/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import THEME from '../../theme.js';
import Badge from '../Badge.js';
const TriggerPreview = (props) => {
    const proceduresLoadable = useProcedures();
    const procedures = h.hasData(proceduresLoadable)
        ? proceduresLoadable.data
        : null;
    const lang = useSelector((s) => s.lang);
    const procedure = procedures?.find((p) => p.procedureId === props.procedureId);
    return (React.createElement("div", null, procedure && (React.createElement(React.Fragment, null,
        React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, lang.triggers[props.id]),
        React.createElement("p", null,
            React.createElement(Link, { to: `/settings/workflows/procedures/${props.procedureId}` }, lang.procedureTitles[props.procedureId] || procedure.title))))));
};
export default TriggerPreview;
//# sourceMappingURL=TriggerPreview.js.map